// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"471":"activity","535":"login"}[chunkId] + "." + {"471":"9df7a5d8","535":"6041da1b"}[chunkId] + ".js";
};